import { render, staticRenderFns } from "./ChatWrapper.vue?vue&type=template&id=ab64d748&scoped=true&"
import script from "./ChatWrapper.vue?vue&type=script&lang=js&"
export * from "./ChatWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChatWrapper.vue?vue&type=style&index=0&id=ab64d748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab64d748",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
